import type { FaireProductEntity } from "../../entity_types/product";

export const p_6uwp6vkjd2: FaireProductEntity = {
  token: "p_6uwp6vkjd2",
  type: "product",
  name: "Bad Bitch birthday greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/138363e80a1a6f49eeea9465d299105a52926bb5452cd7b8f73813abad0e886d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/262f50ac93ebb8c8bb7ae5c7593ad3e705d41b95831fd06eb064cbc9704229a1.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed. 4.25 x 5.5 inches. Illustrated by Dylan Mierzwinski. Printed by Red Cap Cards in Los Angeles, California, USA.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:21:15.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
